import { render } from "./CommentsEdit.vue?vue&type=template&id=3454c3dd&scoped=true"
import script from "./CommentsEdit.vue?vue&type=script&lang=js"
export * from "./CommentsEdit.vue?vue&type=script&lang=js"

import "./CommentsEdit.vue?vue&type=style&index=0&id=3454c3dd&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3454c3dd"]])

export default __exports__